import { CARDS } from '@lunary/tarot-data'

const BY_NUMBER = new Map(CARDS.filter((c) => c.arcana === 'major').map((c) => [c.number, c.id]))
const BY_SUIT = new Map(CARDS.filter((c) => c.suit !== null).map((c) => [`${c.suit}-${c.number}`, c.id]))
const SLUGS = CARDS.map((c) => c.id).sort((a, b) => b.length - a.length)

export function matchCardId(fileName: string): string | null {
  const base = fileName.replace(/\.[^.]+$/, '').toLowerCase()
  const suited = /(wands|cups|swords|pentacles)[-_ ]?(\d{1,2})(?!\d)/.exec(base)
  if (suited?.[1] !== undefined && suited[2] !== undefined) {
    const id = BY_SUIT.get(`${suited[1]}-${Number(suited[2])}`)
    if (id) return id
  }
  const lead = /^(\d{1,2})(?!\d)/.exec(base)
  if (lead?.[1] !== undefined) {
    const id = BY_NUMBER.get(Number(lead[1]))
    if (id) return id
  }
  return SLUGS.find((slug) => base.includes(slug)) ?? null
}
